import { apiFetch } from './apiFetch';
import type { BoxSettings, BoxSettingsUpdate } from '@deposits/shared';

export async function fetchBoxSettings(): Promise<BoxSettings> {
  return apiFetch<BoxSettings>('/box-settings');
}

export async function updateBoxSettings(body: BoxSettingsUpdate): Promise<BoxSettings> {
  return apiFetch<BoxSettings>('/box-settings', {
    method: 'PUT',
    body: JSON.stringify(body),
  });
}
